<template>
    <div class="gst-user-avatar">
        <v-avatar
            v-if="userDetails.name"
            color="primary"
            class="mt-6 mb-4 gst-user-avatar__icon"
            :class="{
                'gst-user-avatar__icon--minimized': isMinimized,
            }"
            :size="isMinimized ? 48 : 100">
            <span class="white-text">
                {{ computedAvatarInitials }}
            </span>
        </v-avatar>
        <h5
            v-if="!isMinimized"
            class="gst-user-avatar__name">
            {{ userDetails && userDetails.name }}
        </h5>
        <p
            v-if="showUserPartner"
            class="gst-user-avatar__partner">
            {{ userPartners[0].name }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'UserAvatar',
    props: {
        isMinimized: {
            type: Boolean,
            default: false,
        },
        userDetails: {
            type: Object,
            default: null,
        },
        userPartners: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        computedAvatarInitials() {
            let initials = '';
            initials += this.userDetails.given_name && this.userDetails.given_name.charAt(0);
            initials +=
                !this.isMinimized && this.userDetails.family_name
                    ? this.userDetails.family_name.charAt(0)
                    : '';
            return initials.toUpperCase();
        },
        showUserPartner() {
            return !this.isMinimized && this.userPartners && this.userPartners.length === 1;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '@scssVariables';

.gst-user-avatar {
    .gst-user-avatar__icon {
        margin: theme-spacing(0) auto;
        transition: all 0.2s ease;

        span {
            font-weight: font-weight('bold');
            font-size: font-size('7xl');
            transition: all 0.2s ease;
        }
    }

    .gst-user-avatar__name,
    .gst-user-avatar__partner {
        display: inline-block;
        width: 100%;
    }

    .gst-user-avatar__partner {
        font-size: font-size('2xs');
        color: theme-color('septenary');
    }

    .gst-user-avatar__icon--minimized {
        margin: theme-spacing(0) theme-spacing(n1);
        span {
            font-size: font-size('4xl');
        }
    }
}
</style>
